const LANGUAGE_STYLE_MAP = {
  english: {
    label: 'English',
    color: '#1976d2',
    bgColor: '#e3f2fd',
  },
  korea: {
    label: 'Korean',
    color: '#d32f2f',
    bgColor: '#ffebee',
  },
};

const LANGUAGE_STYLE_FALLBACKS = [
  { color: '#6a1b9a', bgColor: '#f3e5f5' },
  { color: '#2e7d32', bgColor: '#e8f5e9' },
  { color: '#ef6c00', bgColor: '#fff3e0' },
  { color: '#00838f', bgColor: '#e0f7fa' },
  { color: '#5d4037', bgColor: '#efebe9' },
];

const toLanguageLabel = (value) => {
  const normalized = String(value || '').trim();
  if (!normalized) return 'Language';

  return normalized
    .split(/[_\-\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const getFallbackStyle = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  const hash = normalized.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return LANGUAGE_STYLE_FALLBACKS[hash % LANGUAGE_STYLE_FALLBACKS.length];
};

export const getLanguageDisplayInfo = (category) => {
  const normalized = String(category || '').trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  const mapped = LANGUAGE_STYLE_MAP[normalized];
  if (mapped) return mapped;

  return {
    label: toLanguageLabel(category),
    ...getFallbackStyle(category),
  };
};
